module.exports = __webpack_public_path__ + "img/user-alt-slash.9c014fb4.svg";